export default __webpack_public_path__ + "static/media/promo-1.3935d5cb.png";